import { ref } from 'vue'

export function useNotifications() {
  const showModalInfo = ref(false)
  const message = ref({ title: '', content: '' })

  const showSuccess = (title, content) => {
    if (window.Swal) {
      return window.Swal.fire({
        title,
        text: content,
        icon: 'success',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1A0054',
        background: '#ffffff',
        color: '#1A0054'
      })
    }
    
    // Fallback to modal
    showModal(title, content)
  }

  const showError = (title, content) => {
    if (window.Swal) {
      return window.Swal.fire({
        title,
        text: content,
        icon: 'error',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#dc3545',
        background: '#ffffff',
        color: '#dc3545'
      })
    }
    
    // Fallback to modal
    showModal(title, content)
  }

  const showWarning = (title, content) => {
    if (window.Swal) {
      return window.Swal.fire({
        title,
        text: content,
        icon: 'warning',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#ffc107',
        background: '#ffffff',
        color: '#856404'
      })
    }
    
    // Fallback to modal
    showModal(title, content)
  }

  const showConfirm = (title, content, confirmText = 'Confirmar', cancelText = 'Cancelar') => {
    if (window.Swal) {
      return window.Swal.fire({
        title,
        text: content,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        confirmButtonColor: '#1A0054',
        cancelButtonColor: '#6c757d',
        background: '#ffffff',
        color: '#1A0054'
      })
    }
    
    // Fallback to browser confirm
    return Promise.resolve({ isConfirmed: confirm(`${title}\n\n${content}`) })
  }

  const showModal = (title, content) => {
    message.value = { title, content }
    showModalInfo.value = true
  }

  const closeModal = () => {
    showModalInfo.value = false
    message.value = { title: '', content: '' }
  }

  // Predefined notifications for common scenarios
  const notifyStudentCreated = () => {
    return showSuccess('¡Éxito!', 'Se ha creado el colaborador correctamente.')
  }

  const notifyStudentUpdated = () => {
    return showSuccess('¡Éxito!', 'Colaborador actualizado exitosamente.')
  }

  const notifyStudentDeleted = () => {
    return showSuccess('¡Éxito!', 'Colaborador eliminado exitosamente.')
  }

  const notifyBulkUploadSuccess = () => {
    return showSuccess('¡Proceso exitoso!', 'Se ha cargado la información de usuarios masivos correctamente.')
  }

  const notifyEmailExists = () => {
    return showWarning('Advertencia', 'El email registrado ya existe.')
  }

  const notifySelectCompany = () => {
    return showWarning('Advertencia!', 'Debe seleccionar una empresa para subir registros masivos.')
  }

  const notifyError = (customMessage = null) => {
    const defaultMessage = 'Hubo un error al procesar la solicitud. Inténtelo nuevamente.'
    return showError('Error', customMessage || defaultMessage)
  }

  return {
    showModalInfo,
    message,
    showSuccess,
    showError,
    showWarning,
    showConfirm,
    showModal,
    closeModal,
    notifyStudentCreated,
    notifyStudentUpdated,
    notifyStudentDeleted,
    notifyBulkUploadSuccess,
    notifyEmailExists,
    notifySelectCompany,
    notifyError
  }
}